export class AbstractFilterComponent {

	constructor(parent, filter, node) {
		this.parent = parent;
		this.filter = filter;
		this.node = node;
	}

	componentStateChanged() {
		let self = this;

		// inform parent component
		self.parent['childComponentChangedState'](this);
	}

	childComponentChangedState() {
		let self = this;

		// bubble
		self.componentStateChanged();
	}
}
